import { render, staticRenderFns } from "./BatchGlosses.vue?vue&type=template&id=952ba482"
import script from "./BatchGlosses.vue?vue&type=script&lang=js"
export * from "./BatchGlosses.vue?vue&type=script&lang=js"
import style0 from "./BatchGlosses.vue?vue&type=style&index=0&id=952ba482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports